import gql from "graphql-tag";
const SYSTEM_SETTINGS = gql`
	query (
		$where: SystemSettingFilterInput
		$order: [SystemSettingSortInput!]
	) {
		systemSettings(where: $where, order: $order) {
			items {
				id
				code
				name
				value
			}
		}
	}
`;
const GET_SYSTEM_SETTING_VALUE_BY_CODE = gql`
	query ($code: String!) {
		value: systemSettingValueByCode(code: $code)
	}
`;
const EDIT_SYSTEM_SETTINGS = gql`
	mutation ($inputs: [BaseEntityWithValueInput!]!) {
		systemSettings(inputs: $inputs)
	}
`;
export {
  EDIT_SYSTEM_SETTINGS,
  GET_SYSTEM_SETTING_VALUE_BY_CODE,
  SYSTEM_SETTINGS
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3lzdGVtLXNldHRpbmdzLmpzIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZ3JhcGhxbC9zeXN0ZW0tc2V0dGluZ3MudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGdxbCBmcm9tIFwiZ3JhcGhxbC10YWdcIjtcblxuZXhwb3J0IGNvbnN0IFNZU1RFTV9TRVRUSU5HUyA9IGdxbGBcblx0cXVlcnkgKFxuXHRcdCR3aGVyZTogU3lzdGVtU2V0dGluZ0ZpbHRlcklucHV0XG5cdFx0JG9yZGVyOiBbU3lzdGVtU2V0dGluZ1NvcnRJbnB1dCFdXG5cdCkge1xuXHRcdHN5c3RlbVNldHRpbmdzKHdoZXJlOiAkd2hlcmUsIG9yZGVyOiAkb3JkZXIpIHtcblx0XHRcdGl0ZW1zIHtcblx0XHRcdFx0aWRcblx0XHRcdFx0Y29kZVxuXHRcdFx0XHRuYW1lXG5cdFx0XHRcdHZhbHVlXG5cdFx0XHR9XG5cdFx0fVxuXHR9XG5gO1xuXG5leHBvcnQgY29uc3QgR0VUX1NZU1RFTV9TRVRUSU5HX1ZBTFVFX0JZX0NPREUgPSBncWxgXG5cdHF1ZXJ5ICgkY29kZTogU3RyaW5nISkge1xuXHRcdHZhbHVlOiBzeXN0ZW1TZXR0aW5nVmFsdWVCeUNvZGUoY29kZTogJGNvZGUpXG5cdH1cbmA7XG5cbi8vIFRPRE86IGltcGxlbWVudCB0aGlzIGZ1bmN0aW9uIG9uIHRoZSBzZXJ2ZXIgc2lkZVxuLy8gZXhwb3J0IGNvbnN0IEdFVF9TWVNURU1fU0VUVElOR19WQUxVRVNfQllfQ09ERSA9IGdxbGBcbi8vIFx0cXVlcnkgKCRjb2RlczogW1N0cmluZyFdISkge1xuLy8gXHRcdHN5c3RlbVNldHRpbmdzKHdoZXJlOiB7IGNvZGU6IHsgaW46ICRjb2RlcyB9IH0pIHtcbi8vIFx0XHRcdGl0ZW1zIHtcbi8vIFx0XHRcdFx0Y29kZVxuLy8gXHRcdFx0XHR2YWx1ZVxuLy8gXHRcdFx0fVxuLy8gXHRcdH1cbi8vIFx0fVxuLy8gYDtcblxuZXhwb3J0IGNvbnN0IEVESVRfU1lTVEVNX1NFVFRJTkdTID0gZ3FsYFxuXHRtdXRhdGlvbiAoJGlucHV0czogW0Jhc2VFbnRpdHlXaXRoVmFsdWVJbnB1dCFdISkge1xuXHRcdHN5c3RlbVNldHRpbmdzKGlucHV0czogJGlucHV0cylcblx0fVxuYDtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBRU8sTUFBTSxrQkFBa0I7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBZ0J4QixNQUFNLG1DQUFtQztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBa0J6QyxNQUFNLHVCQUF1QjtBQUFBO0FBQUE7QUFBQTtBQUFBOyJ9
